import { takeLatest, call, put } from 'redux-saga/effects';
import { GatewayManagementApi } from 'api';
import { apiCallStatus, NOTIFICATION_TYPES } from 'helpers/constants';
import logger from 'helpers/logger';
import { actionTypes } from './constants';
import { refreshGatewayAction } from './actions';
import { notify } from 'sharedComponents/GeneralNotification';

function* refreshGateway({ gatewayID }) {
    yield put(refreshGatewayAction(apiCallStatus.LOADING));
    try {
        const response = yield call(GatewayManagementApi.refreshGateway, gatewayID);
        yield put(refreshGatewayAction(apiCallStatus.SUCCESS, response));
        logger.debug('Refresh Gateway successfully triggered for page ');
    } catch (err) {
        yield put(refreshGatewayAction(apiCallStatus.ERROR, [], err));
        notify(err?.message, NOTIFICATION_TYPES.ERROR, true);
    }
}
export function* refreshGatewayWatchers() {
    yield takeLatest(actionTypes.REFRESH_GATEWAY, refreshGateway);
}
